import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import Toggle from 'react-toggle'

import {
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    ListGroup,
    ListGroupItem,
    Row,
    Col,
    Form,
    FormGroup,
    Label,
    Input,
    ListGroupItemHeading,
    ListGroupItemText
} from "reactstrap"
import AsyncSelect from 'react-select/async'

import Utils from "../../Utils"

const TablaPrecuotas = ({ cotizacion }) => {

    const { anotaciones, meses, cuotas, mensualidad, inicial } = cotizacion

    return (
    <>
        {(anotaciones.length >0) &&
            <Card className="my-2">
                <CardHeader className="bg-warning text-white h5">Anotaciones</CardHeader>
                <CardBody>
                    <ListGroup>
                        {anotaciones.map((item, indx) => (
                            <ListGroupItem style={{ justifyContent: "center", alignItems: "center"  }} className="d-flex flex-row justify-content-between" key={indx}>
                                <ListGroupItemHeading className="m-0">{item.label}</ListGroupItemHeading>
                                {(item.type == "descuento") ?
                                    <ListGroupItemText className="text-danger m-0">-${Utils.formatPrice(item.monto)}</ListGroupItemText>
                                    :
                                    <ListGroupItemText className="m-0">${Utils.formatPrice(item.monto)}</ListGroupItemText>
                                }
                            </ListGroupItem>
                        ))}
                    </ListGroup>
                </CardBody>
            </Card>
        }
        <Card className="my-2">
            <CardHeader className="bg-primary text-white h5">{meses.length} Cuotas de ${mensualidad}</CardHeader>
            <CardBody>
                <ListGroup>
                    {cuotas.map((item, indx) => (
                        <ListGroupItem key={indx}>
                            <ListGroupItemHeading>{item.label}: ${Utils.formatPrice(item.monto)}</ListGroupItemHeading>
                            <ListGroupItemText>Fecha de Pago: {Utils.dayjs(item.fecha).format('DD [de] MMMM [del] YYYY')}</ListGroupItemText>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            </CardBody>
        </Card>
        
    </>
    )
}

const ElegirPropietario = ({ onChange, value }) => {

    const [propietario, setPropietario] = useState({})

    const fetchPersona = async (q, callback) => {
        if(q.trim().length <3) {
            return;
        }
        // perform search
        try {
            const { data } = await Utils.API.BuscarPersona(q)
            const maped = data.map(({ idUsuario, Nombre, DNI }) => ({ label: `${Nombre} / ${DNI}`, value: idUsuario }));
            callback(maped)
        } catch(err) {
            Utils.AlertError(err, "No se pudo buscar a la persona")
        }
    }

    return(
        <Card className="my-2">
            <CardHeader className="bg-primary text-white h5">Elegir Propietario</CardHeader>
            <CardBody>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Ingrese el Nombre o el DNI:</Label>
                            <AsyncSelect
                                placeholder={"Ingrese el Nombre o DNI del Cliente"}
                                loadOptions={fetchPersona}
                                onChange={onChange}
                                value={value}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

const Resumen = ({ toggleResumen, cotizacion, propietario }) => {

    const venderLote = async () => {
        if(window.confirm("Realmente desea vender este Lote?") == false) {
            return;
        }
        //
        const { value:idUsuario } = propietario
        const { token } = cotizacion

        try {
            await Utils.API.VenderLote(token, idUsuario)
            alert("Lote Vendido!")
        } catch(err) {
            Utils.AlertError(err, "No se pudo vender el Lote")
        }
    }

    return(
        <>
            <Row>
                <Col sm={3}>
                    <Button onClick={toggleResumen}>
                        <i className="fa-solid fa-arrow-left"></i> Configurar Cuotas
                    </Button>
                </Col>
            </Row>
            <Card className="my-2">
                <CardHeader className="bg-success text-white h5">Resumen de Venta: {cotizacion.lote.Nombre} (Etapa {cotizacion.lote.Etapa}) / {cotizacion.lote.Manzana}-{cotizacion.lote.Lote}</CardHeader>
                <CardBody>
                    <h3>Comprador: {propietario.label}</h3>
                    <h4>Precio Base: {cotizacion.lote.Precio} / Área: {cotizacion.lote.Area}</h4>
                    <h4>Total a Pagar: {cotizacion.precio} / Inicial: {cotizacion.inicial}</h4>
                    <h4>Cuotas: {cotizacion.meses.length} / Mora Diaria: {cotizacion.lote.MoraDiaria}</h4>
                    <TablaPrecuotas cotizacion={cotizacion} />
                    <Button onClick={venderLote} color="success" size="lg" block>Comprar</Button>
                </CardBody>
            </Card>
        </>
    )
}

const Cotizador = () => {

    const [showResumen, setShowResumen] = useState(false)

    const toggleResumen = () => {
        setShowResumen(
            !showResumen
        )
    }

    const [cotizacion, setCotizacion] = useState(null)

    const [_cuotas, setCuotas] = useState(0)
    const [_inicial, setInicial] = useState(0)
    const [_precio, setPrecio] = useState(0)
    const [_propietario, setPropietario] = useState()
    const [_diaMes, setDiaMes] = useState(1)
    const [_reserva, setReserva] = useState(false)

    const handleReservaChange = ({ target }) => {
        setReserva(target.checked)
    }


    const [searchParams, setSearchParams] = useSearchParams()
    const idLote = searchParams.get('idLote')

    const fetchCotizacion = async () => {
        try {
            const { data } = await Utils.API.CotizarLote(idLote, _cuotas, _precio, _inicial, _diaMes, _reserva)
            setCotizacion(data)
            setCuotas(data.meses.length)
            setPrecio(data.precio)
            setInicial(data.inicial)
        } catch(err) {
            Utils.AlertError(err, "No se pudo obtener la inforamción del Lote")
        }
    }

    const configurarCuotas = event => {
        event.preventDefault()
        fetchCotizacion()
    }

    useEffect(() => {
        fetchCotizacion()
    }, [])
    

    return(
        <Container>
            {idLote ?
                <>
                    {(cotizacion == null) ?
                        <Alert className="text-center h3" color="info">Cargando...</Alert>
                        :
                        <>
                            {showResumen ?
                                <Resumen
                                    toggleResumen={toggleResumen}
                                    cotizacion={cotizacion}
                                    propietario={_propietario}
                                />
                            :
                            <>
                                <h1>{cotizacion.lote.Nombre} (Etapa {cotizacion.lote.Etapa}) / {cotizacion.lote.Manzana}-{cotizacion.lote.Lote}:</h1>
                                <h2>Precio: {cotizacion.lote.Precio} / Área: {cotizacion.lote.Area}</h2>
                                <h4>Máximo de cuotas: {cotizacion.lote.MaxCuotas} / Mora Diaria: {cotizacion.lote.MoraDiaria}</h4>
                                <Card>
                                    <CardHeader className="bg-primary text-white h5">Configurar Cuotas</CardHeader>
                                    <CardBody>
                                        <Form onSubmit={configurarCuotas}>
                                            <Row>
                                                <Col sm={1}>
                                                    <Row>
                                                        <Label htmlFor='reserva-status'>Reserva:</Label>
                                                    </Row>
                                                    <Toggle
                                                        id='reserva-status'
                                                        checked={_reserva}
                                                        onChange={handleReservaChange}
                                                    />
                                                    
                                                </Col>
                                                <Col>
                                                    <FormGroup>
                                                        <Label>Precio:</Label>
                                                        <Input
                                                            value={_precio}
                                                            type="number"
                                                            min={1}
                                                            max={cotizacion.lote.Precio}
                                                            step="0.01"  
                                                            onChange={({ target }) => { setPrecio(target.value) }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col>
                                                    <FormGroup>
                                                        <Label>Día de Pago:</Label>
                                                        <Input
                                                            value={_diaMes}
                                                            type="select"
                                                            onChange={({ target }) => { setDiaMes(target.value) }}
                                                        >
                                                            <option>1</option>
                                                            <option>15</option>
                                                            <option>30</option>
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label>Cuotas:</Label>
                                                        <Input
                                                            value={_cuotas}
                                                            type="number"
                                                            min={1}
                                                            max={cotizacion.lote.MaxCuotas}
                                                            step={1}
                                                            onChange={({ target }) => { setCuotas(target.value) }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col>
                                                    <FormGroup>
                                                        <Label>Inicial:</Label>
                                                        <Input
                                                            value={_inicial}
                                                            type="number"
                                                            min={0}
                                                            step="0.01"
                                                            max={100}
                                                            //max={cotizacion.lote.Precio}
                                                            onChange={({ target }) => { setInicial(target.value) }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Button size="lg" block>Configurar Cuotas</Button>
                                        </Form>
                                    </CardBody>
                                </Card>
                                {(cotizacion != null) && <TablaPrecuotas cotizacion={cotizacion} />}
                                <ElegirPropietario onChange={setPropietario} value={_propietario} />
                                <Button disabled={!_propietario} onClick={toggleResumen} className="mb-2" size="lg" color="success" block>Generar Resumen</Button>
                            </>
                            }
                        </>
                    }
                </>
                :
                <Alert color="danger">No se especificó un Lote</Alert>
            }
        </Container>
    )
}

export default Cotizador